export const UserData = (data) => {
    return {
      type: 'UserData',
      payload: data
    }
}